export const CREATE_PRODUCT_THICKNESS = 'CREATE_PRODUCT_THICKNESS'
export const GET_LIST_PRODUCT_THICKNESS = 'GET_LIST_PRODUCT_THICKNESS'
export const DETAIL_PRODUCT_THICKNESS = 'DETAIL_PRODUCT_THICKNESS'
export const PATCH_PRODUCT_THICKNESS = 'PATCH_PRODUCT_THICKNESS'
